// import external dependencies
import 'jquery';

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

// add the imported icons to the library
library.add(far, fab)

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();


// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import about from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  about,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js